



















































import Vue from 'vue';
import { mapActions } from 'vuex';
import NewEventSlat from './NewEventSlat.vue';
import { HubButton } from '../HubComponents';

export default Vue.extend({
  name: 'EventsTable' as string,
  components: {
    NewEventSlat,
    HubButton,
  },
  props: {
    secret: {
      type: String,
      default: '',
    },
    events: {
      type: Array as () => Store.Events.Event[],
      default: () => [],
    },
    value: {
      type: String,
      default: 'desc',
    },
  },
  data() {
    return {
      selecteds: [] as Components.Events.EventsSelect[],
      checkSelectAll: false as boolean,
      allSelected: false as boolean,
      anySelected: false as boolean,
      id_customer: 0,
      username: '',
    };
  },
  watch: {
    selecteds: {
      handler(next) {
        this.allSelected = this.selecteds.every(({ selected }) => selected);
        this.anySelected = this.selecteds.some(({ selected }) => selected);
        if (!next.some((select: boolean) => select)) {
          this.checkSelectAll = false;
        }
        this.checkSelectAll = this.allSelected;
      },
      deep: true,
    },
  },
  mounted() {
    this.selecteds = this.events.map((event: Components.Events.EventsSelect) => ({
      id: event.id,
      selected: false,
    }));
  },
  methods: {
    ...mapActions('events', { remove: 'remove' }),
    selectAll() {
      if (!this.events.length) {
        return;
      }
      if (this.allSelected) {
        for (let i = 0; i < this.events.length; i += 1) {
          this.selecteds[i].selected = false;
        }
        this.allSelected = false;
        this.anySelected = false;
        this.checkSelectAll = false;
      } else {
        for (let i = 0; i < this.events.length; i += 1) {
          this.selecteds[i].selected = true;
        }
        this.allSelected = true;
        this.checkSelectAll = true;
        this.anySelected = true;
      }
    },
    reload() {
      this.$emit('reload');
    },
    removeMany() {
      const arrayToRemove: number[] = [];
      this.selecteds.map(({ id, selected }) => {
        if (id && selected) {
          arrayToRemove.push(id);
        }
        return null;
      });
      this.remove(arrayToRemove);
      this.reload();
    },
  },
});
